import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiResponse, OrganizationContactResponse } from "../../types/certWatch";
import api from "../api/api";
import { RootState } from "../store";

export const getCCOsByOrgIdAndFlag = createAsyncThunk<
  ApiResponse<OrganizationContactResponse>,
  {
    organizationId: string;
    PageNumber: number;
    PageSize: number;
    sortBy: string;
    sortOrder: "asc" | "desc";
    availability?: boolean | null;
    searchTerm?: string;
    designations?: string; // comma-separated
    filterMode?: number;
    certExpirationDate?: Date | null;
    certExpirationDateMode?: "on" | "onorafter" | "onorbefore";
    notesSearchTerm?: string;
    FirstNameSearch?: string;
    LastNameSearch?: string;
    CcoIdSearchTerm?: string;
  },
  { rejectValue: string }
>(
  "ccoAdvance/getCCOsByOrgIdAndFlag",
  async (
    {
      organizationId,
      PageNumber,
      PageSize,
      sortBy,
      sortOrder,
      searchTerm,
      notesSearchTerm,
      FirstNameSearch,
      LastNameSearch,
      CcoIdSearchTerm,
      availability,
      designations,
      filterMode,
      certExpirationDate,
      certExpirationDateMode
    },
    { rejectWithValue }
  ) => {
    try {
      const requestBody: any = {
        OrganizationId: organizationId,
        PageNumber: PageNumber,
        PageSize: PageSize,
        SortBy: sortBy ?? "LastName",
        SortOrder: sortOrder ?? "asc"
      };

      // Add optional filters only if they have values
      if (availability !== null && availability !== undefined) {
        requestBody.Availability = availability;
      }

      if (searchTerm?.trim()) {
        requestBody.SearchTerm = searchTerm.trim();
      }

      if (notesSearchTerm?.trim()) {
        requestBody.NotesSearchTerm = notesSearchTerm.trim();
      }

      if (FirstNameSearch?.trim()) {
        requestBody.FirstNameSearch = FirstNameSearch.trim();
      }

      if (LastNameSearch?.trim()) {
        requestBody.LastNameSearch = LastNameSearch.trim();
      }

      if (CcoIdSearchTerm?.trim()) {
        requestBody.CcoIdSearchTerm = CcoIdSearchTerm.trim();
      }

      if (designations?.trim()) {
        requestBody.Designations = designations.trim();
        requestBody.FilterMode = filterMode ?? 0;
      }

      if (certExpirationDate && certExpirationDateMode) {
        requestBody.CertExpirationDate = certExpirationDate;
        requestBody.CertExpirationDateMode = certExpirationDateMode;
      }


      const response = await api.post(
        "certWatch/getCCOsByOrgIdAndFlag",
        requestBody,
        {
          headers: { "Content-Type": "application/json" },
        }
      );

      if (response.data?.Success && response.data.Data) {
        return {
          Data: {
            Items: response.data.Data.Items ?? [],
            TotalCount: response.data.Data.TotalCount ?? 0,
            PageNumber: response.data.Data.PageNumber ?? PageNumber,
            PageSize: response.data.Data.PageSize ?? PageSize,
            TotalPages:
              response.data.Data.TotalPages ??
              Math.ceil((response.data.Data.TotalCount ?? 0) / PageSize),
          },
          Success: response.data.Success,
          Message: response.data.Message,
          ApiCode: response.data.ApiCode,
        };
      }

      return rejectWithValue(response.data?.Message || "Failed to fetch CCOs");
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.Message || error.message
      );
    }
  }
);

